import React from 'react';
import copilotLogo from '../../assets/images/copilot-logo.webp';
import copilotBannerBg from '../../assets/images/red-bg.png';
import copilotBannerHome from '../../assets/images/copilot-banner-home.png';
import copilotBannerService from '../../assets/images/copilot-banner-service.png';
import copilotBannerHelp from '../../assets/images/copilot-banner-help.png';
import { platformConfig, PlatformType } from './platform';

export type AuthBrandKey = 'PLATFORM' | 'COPILOT';

export interface AuthBrandSlide {
  image: string;
  /** content-string key'i (useContent ile çözülür) */
  textKey: string;
}

export interface AuthBrand {
  loginLogo: string;
  loginLogoClassName: string;
  loginLogoStyle: React.CSSProperties;
  /**
   * Doluysa logonun yanına bu metin yazılır (AuthTitle logo + metin düzenine
   * geçer). Boşsa sadece logo görseli render edilir.
   */
  loginLogoText?: string;
  bannerBg: string;
  /**
   * Slide görsellerinin oranı; boyutlandırma sınıfları LeftBanner içinde seçilir.
   * Tailwind sadece src/pages ve src/components altını taradığı için sınıf
   * isimleri bu dosyada tutulmamalı (tailwind.config.js -> content).
   */
  bannerImageFit: 'landscape' | 'portrait';
  slides: AuthBrandSlide[];
}

const platformBannerTextKeys: Record<PlatformType, string[]> = {
  HEDEFNET: [
    'hedefnet.login.banner.one',
    'hedefnet.login.banner.two',
    'hedefnet.login.banner.three',
  ],
  FILOMINGO: [
    'filomingo.login.banner.one',
    'filomingo.login.banner.two',
    'filomingo.login.banner.three',
  ],
};

const platformBrand: AuthBrand = {
  loginLogo: platformConfig.loginLogo,
  loginLogoClassName: platformConfig.loginLogoClassName,
  loginLogoStyle: platformConfig.loginLogoStyle,
  bannerBg: platformConfig.bannerBg,
  bannerImageFit: 'landscape',
  // Platform banner'ında üç slide da aynı görseli kullanır, sadece metin değişir.
  slides: platformBannerTextKeys[platformConfig.type].map((textKey) => ({
    image: platformConfig.bannerImage,
    textKey,
  })),
};

const copilotBrand: AuthBrand = {
  loginLogo: copilotLogo,
  loginLogoClassName: '',
  // Logo + "Copilot" metnini saran kabın boşlukları; Hedefnet'teki logo
  // marjlarıyla aynı hizada dursun diye aynı değerler kullanılıyor.
  loginLogoStyle: {
    marginBottom: '3.5rem',
    marginTop: '3.5rem',
  },
  loginLogoText: 'Copilot',
  bannerBg: copilotBannerBg,
  // Portrait telefon mockup'ları; genişlik yerine yükseklikten sınırlanmalı.
  bannerImageFit: 'portrait',
  slides: [
    { image: copilotBannerHome, textKey: 'copilot.login.banner.one' },
    { image: copilotBannerService, textKey: 'copilot.login.banner.two' },
    { image: copilotBannerHelp, textKey: 'copilot.login.banner.three' },
  ],
};

export const authBrands: Record<AuthBrandKey, AuthBrand> = {
  PLATFORM: platformBrand,
  COPILOT: copilotBrand,
};
